import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AppState } from '../store';

/**
 * Quyền của người đang đăng nhập (ma trận phân quyền).
 *   const { can, loaded } = usePermission();
 *   can(PERM.student.practice)           // có quyền này
 *   can([PERM.a, PERM.b])                // có ít nhất một quyền trong danh sách
 * Luôn true khi: super admin, BE chưa ở mode 'enforce' (off / log: BE chưa chặn thì FE cũng không chặn),
 * hoặc không tải được quyền (BE vẫn kiểm tra lại).
 * Luôn false khi chưa tải xong quyền (loaded = false, vd vừa đăng nhập SSO): chỗ nào không muốn ẩn rồi hiện lại
 * thì kiểm tra loaded (PermissionGuard hiện spinner).
 */
export const usePermission = () => {
    const rbac = useSelector((state: AppState) => state.auth.rbac);
    const loaded = rbac !== null;

    const can = useCallback((permission: string | readonly string[]) => {
        if (!rbac) return false;
        if (rbac.failed || rbac.is_super_admin || rbac.mode !== 'enforce') return true;
        const keys = typeof permission === 'string' ? [permission] : permission;
        return keys.some(key => rbac.permissions.includes(key));
    }, [rbac]);

    return { can, loaded, rbac };
};
